import { Seating } from '../data/beans/Section';

/** Counts: [seat capacity, occupied, waitlist capacity, waitlisted]. */
export default function formatSeatCount(
  seating: Seating | null,
  offset: 0 | 2
): string {
  if (seating === null) return 'Loading...';
  const total = seating[0][offset];
  const occupied = seating[0][offset + 1];
  return typeof total === 'number' &&
    Number.isFinite(total) &&
    total >= 0 &&
    typeof occupied === 'number' &&
    Number.isFinite(occupied) &&
    occupied >= 0
    ? `${occupied}/${total}`
    : 'N/A';
}

export function normalizeSeatingData(
  raw: Seating
): import('../types').SeatData {
  const read = (offset: 0 | 2): import('../types').OccupiedInfo | null => {
    const total = raw[0][offset];
    const occupied = raw[0][offset + 1];
    return typeof total === 'number' &&
      Number.isFinite(total) &&
      total >= 0 &&
      typeof occupied === 'number' &&
      Number.isFinite(occupied) &&
      occupied >= 0
      ? { total, occupied }
      : null;
  };
  return { inClass: read(0), waitlist: read(2) };
}
